<template>
  <div class="lightblue-text-btn ml-8">
    <el-button :type="type" :disabled="disabled" @click="handelPrimaryBtn">
      {{ btnText }}
    </el-button>
  </div>
</template>

<script>
import i18n from '@/lang'
export default {
  name: 'LightBlueTextBtn',
  props: {
    btnText: {
      type: String,
      default: i18n.t('button.ok')
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'lightblue'
    },
  },
  methods: {
    handelPrimaryBtn() {
      this.$emit('lightblue')
    }
  }
}
</script>

<style lang="scss" scoped>
.lightblue-text-btn {
  :deep(.el-button) {
    min-width: 90px !important;
    padding: 0;
    text-align: center;
    height: 36px !important;
    font-size: 14px !important;
  }
  :deep(.el-button--tab) {
    background-color: #606060;
    border-color: #606060;
    border: none;
    color: #FFFFFF;

    &:hover {
      background-color: #4a4a4a;
      border-color: #4a4a4a;
      color: #FFFFFF;
    }
    &:focus {
      background-color: #606060 !important;
      color: #FFFFFF;
    }
    &:active {
      background-color: #136aff !important;
      color: #fff;
    }
  }
}
</style>
